export const Experiments = {
  donate_now_track_click: 'donate_now_track_click',

  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  CustomBrandingFrpFeature: {
    featureKey: 'custom_branding_on_fundraising_pages',
    customBrandingFrpAbExperiment: {
      experimentKey: 'custom_branding_on_fundraising_pages',
      variations: {
        charityBranding: 'charity-branding',
        jgDefaultColours: 'jg-default-colours',
      },
    },
  },

  AboveTheFoldCtaProgressBarFrpFeature: {
    featureKey:
      'consumerairwalk_-_legacyfrp_-_conversion_-_above_the_fold__8f7s2',
    AboveTheFoldCtaProgressBarFrpAbExperiment: {
      experimentKey:
        'consumerairwalk_-_legacyfrp_-_conversion_-_above_the_fold__8f7s2',
      variations: {
        DefaultFrpLayout: 'default-frp-layout',
        AboveFoldCtaProgressBarMobile: 'above-fold-cta-progress-bar-mobile',
      },
    },
  },

  ShareButtonBorderFeature: {
    featureKey: 'consumerairwalk_frp_share_button_border',
    ShareButtonBorderExperiment: {
      experimentKey: 'consumerairwalk_frp_share_button_border',
      variations: {
        ShareLink: 'share_link',
        BorderedShareButton: 'bordered_share_button',
      },
    },
  },

  IncreaseShareModalOptionsFeature: {
    featureKey: 'consumerairwalk_frp_shareclick_increase_share_options',
    IncreaseShareModalOptionsExperiment: {
      experimentKey: 'consumerairwalk_frp_shareclick_increase_share_options',
      variations: {
        IncreasedShareModalOptions: 'increased_share_modal_options',
        LegacyFrpDefaultShareModal: 'legacy_frp_default_share_modal',
      },
    },
  },
  TopOfPageStickyCTAsFeature: {
    featureKey: 'consumerairwalk_legacyfrp_conversion_sticky_ctas',
    TopOfPageStickyCTAsExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_conversion_sticky_ctas',
      variations: {
        DefaultBottomOfPageStickyCTAs: 'default_bottom_of_page_sticky_ctas',
        TopOfPageStickyCTAs: 'top_of_page_sticky_ctas',
      },
    },
  },

  ConsumerFintech: {
    CheckoutConversion: {
      EmbeddedCheckoutF4: {
        flag: 'consumerfintech_jgcheckout_conversion_embedded_checkout_f4',
        applePayFlag:
          'consumerfintech_jgcheckout_conversion_embedded_checkout_f4_applepay',
      },
    },
  },
};
